const resource = 'reviews'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}/index/public`, { params })
  },
  postReview(id, params) {
    return $axios.$post(`/${resource}/store_for_order_variant/${id}`, params)
  },
  featuredReviews(params) {
    return $axios.$get(`/${resource}/index/featured`, { params })
  },
  fetchHomeFeatured() {
    return $axios.$get('/v2/home-featured-reviews')
  },
  fetchBestBulbsVehicleReviews(vehicleId, params) {
    return $axios.$get(`/v2/best-bulbs/${vehicleId}/reviews`, { params })
  },
  fetchVehicleSearchPageReviews(vehicleId) {
    return $axios.$get(`/v2/vehicle-search-page/${vehicleId}/reviews`)
  },
  fetchMediaRequest(token) {
    return $axios.$get(`/${resource}/media/${token}`)
  },
  postMedia(token, formData) {
    return $axios.$post(`/${resource}/media/${token}`, formData)
  },
  getServiceName: name => 'reviewsService',
})
